import { BdkFeatureIndicator } from '@breuni-ui/bdk-feature-indicator';
import { safeDefine } from '@breuni-ui/safe-define';

// empty by intention
class EntsFeatureIndicator extends BdkFeatureIndicator {}

safeDefine('ents-feature-indicator', EntsFeatureIndicator);
